import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  image: string;
  readTime: string;
}

const blogPosts: BlogPost[] = [
  {
    id: 1,
    title: 'Best Fall Camping Spots in Hudson Valley',
    excerpt: 'Discover the most stunning autumn camping destinations where foliage meets adventure. Experience the vibrant colors of fall while enjoying the great outdoors.',
    category: 'Destinations',
    author: 'Sarah Mitchell',
    date: 'Jan 15, 2025',
    readTime: '5 min read',
    image: 'https://public.readdy.ai/ai/img_res/809c727b245f4176495ca652afdcf863.jpg',
  },
  {
    id: 2,
    title: 'RV Maintenance Tips for Winter Storage',
    excerpt: 'Essential checklist to prepare your RV for the cold season and ensure it stays in top condition. Learn how to winterize your vehicle properly.',
    category: 'Tips & Guides',
    author: 'Mike Johnson',
    date: 'Jan 12, 2025',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=RV%20camper%20maintenance%20in%20winter%2C%20winterized%20RV%20covered%20with%20snow%2C%20RV%20storage%20preparation%2C%20cold%20weather%20camping%20vehicle%2C%20simple%20clean%20background&width=600&height=400&seq=blog-rv-winter-1&orientation=landscape',
  },
  {
    id: 3,
    title: 'Family-Friendly Campgrounds Near NYC',
    excerpt: 'Top picks for camping with kids, featuring playgrounds, swimming, and easy hiking trails. Make memories with your family in nature.',
    category: 'Family',
    author: 'Emily Chen',
    date: 'Jan 10, 2025',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=family%20camping%20with%20children%2C%20kids%20playing%20at%20campground%2C%20family%20tent%20camping%2C%20playground%20and%20camping%20area%2C%20happy%20outdoor%20family%20activities%2C%20simple%20background&width=600&height=400&seq=blog-family-camp-1&orientation=landscape',
  },
  {
    id: 4,
    title: 'Hiking the Appalachian Trail Through NY',
    excerpt: 'A comprehensive guide to the New York section of the AT with camping recommendations. Explore one of America\'s most iconic trails.',
    category: 'Hiking',
    author: 'David Torres',
    date: 'Jan 8, 2025',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=Appalachian%20Trail%20hiking%20in%20New%20York%2C%20mountain%20trail%20through%20forest%2C%20backpacker%20on%20scenic%20trail%2C%20wilderness%20hiking%20path%2C%20beautiful%20mountain%20landscape%2C%20simple%20natural%20background&width=600&height=400&seq=blog-at-hiking-1&orientation=landscape',
  },
  {
    id: 5,
    title: 'Campfire Cooking: Easy Outdoor Recipes',
    excerpt: 'Delicious and simple meals you can prepare over an open fire during your camping trip. Elevate your outdoor dining experience.',
    category: 'Cooking',
    author: 'Lisa Anderson',
    date: 'Jan 5, 2025',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=campfire%20cooking%20outdoors%2C%20food%20being%20prepared%20over%20open%20fire%2C%20camping%20meal%20preparation%2C%20cast%20iron%20cooking%20at%20campsite%2C%20cozy%20evening%20campfire%2C%20simple%20background&width=600&height=400&seq=blog-campfire-cook-1&orientation=landscape',
  },
  {
    id: 6,
    title: 'Wildlife Watching in Hudson Valley Parks',
    excerpt: 'Best locations and times to spot deer, birds, and other wildlife in their natural habitat. Connect with nature on a deeper level.',
    category: 'Nature',
    author: 'Robert Kim',
    date: 'Jan 3, 2025',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=wildlife%20in%20Hudson%20Valley%2C%20deer%20in%20forest%2C%20bird%20watching%20in%20nature%2C%20natural%20habitat%20with%20animals%2C%20peaceful%20woodland%20scene%2C%20simple%20natural%20background&width=600&height=400&seq=blog-wildlife-1&orientation=landscape',
  },
  {
    id: 7,
    title: 'Essential Camping Gear for Beginners',
    excerpt: 'Everything you need to know about selecting the right equipment for your first camping adventure. Start your journey with confidence.',
    category: 'Gear',
    author: 'Sarah Mitchell',
    date: 'Dec 28, 2024',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=camping%20gear%20and%20equipment%20laid%20out%2C%20tent%2C%20sleeping%20bag%2C%20backpack%2C%20camping%20essentials%2C%20organized%20outdoor%20gear%20display%2C%20simple%20clean%20background&width=600&height=400&seq=blog-gear-beginners&orientation=landscape',
  },
  {
    id: 8,
    title: 'Best Sunrise Spots for Photographers',
    excerpt: 'Capture stunning dawn moments at these picturesque Hudson Valley locations. Perfect for photography enthusiasts and nature lovers.',
    category: 'Photography',
    author: 'Mike Johnson',
    date: 'Dec 25, 2024',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20sunrise%20over%20Hudson%20Valley%20mountains%2C%20golden%20hour%20photography%2C%20dramatic%20sky%20colors%2C%20photographer%20at%20scenic%20overlook%2C%20stunning%20dawn%20landscape%2C%20simple%20natural%20background&width=600&height=400&seq=blog-sunrise-photo&orientation=landscape',
  },
  {
    id: 9,
    title: 'Pet-Friendly Camping Adventures',
    excerpt: 'Bring your furry friends along! Discover campgrounds that welcome pets and tips for camping with dogs safely and comfortably.',
    category: 'Pets',
    author: 'Emily Chen',
    date: 'Dec 20, 2024',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=dog%20at%20campsite%20with%20owner%2C%20pet-friendly%20camping%2C%20happy%20dog%20outdoors%20at%20tent%2C%20family%20camping%20with%20pets%2C%20simple%20natural%20background&width=600&height=400&seq=blog-pet-camping&orientation=landscape',
  },
];

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24">
        <section className="py-20 bg-cream">
          <div className="max-w-7xl mx-auto px-6">
            <h1 className="font-serif text-6xl font-bold text-gray-900 mb-6">Our Blog</h1>
            <p className="text-xl text-gray-600 max-w-3xl">
              Stories, tips, and guides from the trail. Explore our latest articles about camping, RVing, and outdoor adventures in the Hudson Valley.
            </p>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-3 gap-8">
              {blogPosts.map((post) => (
                <article
                  key={post.id}
                  className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden group cursor-pointer"
                >
                  <div className="h-56 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="inline-block px-3 py-1 bg-forest/10 text-forest text-xs font-medium rounded-full">
                        {post.category}
                      </span>
                      <span className="text-xs text-gray-500">{post.readTime}</span>
                    </div>
                    
                    <h3 className="font-bold text-xl text-gray-900 mb-3 group-hover:text-forest transition-colors">
                      {post.title}
                    </h3>
                    
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">
                      {post.excerpt}
                    </p>
                    
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-forest/20 rounded-full flex items-center justify-center">
                          <span className="text-forest text-xs font-bold">
                            {post.author.split(' ').map(n => n[0]).join('')}
                          </span>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-900">{post.author}</p>
                          <p className="text-xs text-gray-500">{post.date}</p>
                        </div>
                      </div>
                      <i className="ri-arrow-right-line text-gray-400 group-hover:text-forest group-hover:translate-x-1 transition-all"></i>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;